import React, { FC } from 'react'
import { format } from '@pogokid/util/datetime'
import styles from './TimeSlotGuide.module.css'
import { Locale } from 'date-fns'

interface TimeSlotGuideProps {
  time: Date
  locale: Locale
}

export const TimeSlotGuide: FC<TimeSlotGuideProps> = ({
  time,
  locale,
}) => {
  const isStartOfHour = time.getMinutes() === 0
  return (
    <span className={styles.TimeSlotGuide}>
      {isStartOfHour && (
        <p className={styles.TimeSlotGuide__time}>
          <span className={styles.TimeSlotGuide__hour}>
            {format(time, 'h', { locale })}
          </span>
          <span className={styles.TimeSlotGuide__ampm}>
            {format(time, 'a', { locale }).toLowerCase()}
          </span>
        </p>
      )}
    </span>
  )
}
